<div class="pedido-itens-modal-informacoes">
  <div class="form-row">
    <div class="form-group col-sm-12">
      <label><b>Produto:</b></label>

      <input class="form-control form-control-sm" type="text" name="produto_informacao" [value]="produtoSelecionado != null ? produtoSelecionado.name : ''" disabled />
    </div>
  </div>

  @if (produtoSelecionado.ficha_tecnica != null && produtoSelecionado.ficha_tecnica != '') {
    <hr class="mt-2 mb-2" />
    <div class="d-flex flex-column">
      <h6 class="text-secondary">
        <b>Ficha Técnica:</b>
      </h6>
      <h6 class="produto_informacoes_ficha_tecnica">
        <b>{{ produtoSelecionado.ficha_tecnica }}</b>
      </h6>
    </div>
  }

  @if (fichasTecnicas.length > 0) {
    <hr class="mt-2 mb-2" />
    <div class="table-responsive pedido-itens-modal-informacoes-grid">
      <table class="table table-sm pedido-itens-modal-informacoes-tabela">
        <thead>
          <tr>
            <th>Link</th>
          </tr>
        </thead>
        <tbody>
          @for (produtoFichaTecnica of fichasTecnicas; track produtoFichaTecnica) {
            <tr>
              <td data-label="Link">
                <a href="{{ produtoFichaTecnica.link }}" target="_blank">{{ produtoFichaTecnica.titulo }}</a>
              </td>
            </tr>
          }
        </tbody>
      </table>
    </div>
  }
</div>
